import client from './client';
import type { TripRouteResponse, TripPositionResponse } from '@/types/route';

export async function getTripRoute(
  alias: string,
  refresh = false,
  truckLat?: number,
  truckLon?: number,
): Promise<TripRouteResponse> {
  const params: Record<string, string> = {};
  if (refresh) params.refresh = 'true';
  if (truckLat != null && truckLon != null) {
    params.truck_lat = String(truckLat);
    params.truck_lon = String(truckLon);
  }
  const { data } = await client.get<TripRouteResponse>(`/ares/trip/${alias}/route`, { params });
  return data;
}

export async function getTripPosition(alias: string): Promise<TripPositionResponse> {
  const { data } = await client.get<TripPositionResponse>(`/ares/trip/${alias}/position`);
  return data;
}
